import { Anchor, Button, Group, List, Tooltip, useMantineTheme } from '@mantine/core';
import Text from '@ui/components/Text/Text';
import { useCallback } from 'react';
import Icon from '@ui/components/Icon/Icon';
import { trackLearnMoreClickedInAdvanceUploadsModal } from 'src/services/tracker/trackers/uploads';

type FooterProps = {
	onCancel?: () => void
	onConfirm?: () => void
};

const LIST_STYLE = { color: 'white' };
const TooltipContent = (
	<Text variant="caption-regular">
		<strong>Upload Information:</strong><br />
		<List style={LIST_STYLE} spacing={-2} size="xs">
			<List.Item style={LIST_STYLE}>
				<Text variant="caption-regular" color="white">Duplicated names are uploaded as new rounds.</Text>
			</List.Item>
			<List.Item style={LIST_STYLE}>
				<Text variant="caption-regular" color="white">Unmatched assets are uploaded as new assets.</Text>
			</List.Item>
		</List>
	</Text>
)

const Footer = ( {
	onCancel, onConfirm
}: FooterProps ) => {
	const theme = useMantineTheme();
	const onLearnMoreClick = useCallback( () => trackLearnMoreClickedInAdvanceUploadsModal(), [] );

	return (
		<Group p="8px 16px" position="apart">
			<Group spacing={12} h="100%">
				<Tooltip
					label={TooltipContent}
					offset={10}
				>
					<Group spacing={5} style={{ cursor: 'default' }}>
						<Icon size={14} icon="info_outlined" color={theme.fn.primaryColor()} />
						<Text variant="footnote2">How does it work?</Text>
					</Group>
				</Tooltip>
				<Anchor
					href="https://support.verybusy.io/en/articles/10446688-smart-uploads-beta-feature"
					target="_blank"
					color="blue.5"
					onClick={onLearnMoreClick}
				>
					<Group spacing={3} align="center">
						<Text variant="footnote-semibold">Learn More</Text>
						<Icon size={14} icon="nord-east-arrow" color={theme.fn.primaryColor()} />
					</Group>
				</Anchor>
			</Group>
			<Group spacing={12}>
				<Button
					variant="subtle"
					color="gray.9"
					onClick={onCancel}
				>
					Cancel
				</Button>
				<Button
					size="md"
					onClick={onConfirm}
				>
					Continue upload
				</Button>
			</Group>
		</Group>
	);
}

export default Footer;
